import React from 'react';
import {
  Button,
  CircularProgress,
  Divider,
  Skeleton,
  Stack,
  Toolbar,
  Typography
} from "@mui/material";
import { useUpdateGroupProfile } from "./useUpdateGroupProfile";
import { useParams } from "react-router-dom";
import { UpdateGroupProfileForm } from "./UpdateGroupProfileForm";
import RefreshIcon from "@mui/icons-material/Refresh";
import { Delete } from "@mui/icons-material";
import { UpdateGroupIcon } from "../../../comps/icons/UpdateGroupIcon";
import { useUpdateGroupProductVersionProfile } from "./useUpdateGroupProductVersionProfile";
import { UpdateGroupProductVersionForm } from "./UpdateGroupProductVersionForm";
import { UpdateStrategyDto } from "../../../models/domain/enums";
import { useUpdateGroupUserAccessProfile } from "./useUpdateGroupUserAccessProfile";
import { UpdateGroupUserAccessForm } from "./UpdateGroupUserAccessForm";
import { UpdateGroupAssignedFarmsForm } from "./UpdateGroupAssignedFarmsForm";
import { useUpdateGroupAssignedFarmsProfile } from "./useUpdateGroupAssignedFarmsProfile";
import { useUpdateGroupAvailableFarmsProfile } from "./useUpdateGroupAvailableFarmsProfile";
import { UpdateGroupAvailableFarmsForm } from "./UpdateGroupAvailableFarmsForm";

const UpdateGroupItemPage = () => {
  const {updateGroupId} = useParams();
  const updateGroupProfile = useUpdateGroupProfile(parseInt(updateGroupId || ''));
  const {data, isFetching, isLoading, refetch} = updateGroupProfile.primaryQuery;
  const {isPending: isDeletePending, mutateAsync: deleteGroup} = updateGroupProfile.deleteMutation;

  const updateGroupProductVersionProfile = useUpdateGroupProductVersionProfile(data);
  const updateGroupAssignedFarmsProfile = useUpdateGroupAssignedFarmsProfile(data);
  const updateGroupAvailableFarmsProfile = useUpdateGroupAvailableFarmsProfile(data);
  const updateGroupUserAccessProfile = useUpdateGroupUserAccessProfile(data);

  const onRefetch = React.useCallback(() => refetch(), [refetch]);
  const onDelete = React.useCallback(() => deleteGroup(), [deleteGroup]);

  return (
    <Stack>
      <Toolbar variant="dense">
        <Typography sx={{ mr: 1 }}>
          <UpdateGroupIcon fontSize="large"/>
        </Typography>
        {
          isLoading
            ? <CircularProgress/>
            : <Typography component="h1" variant="h5" color="inherit">
                {data?.name}
              </Typography>
        }

        <Divider orientation="vertical" sx={{ ml: 2, mr: 2 }} flexItem />

        <Button variant="outlined" onClick={onRefetch} >
          <Typography>Refresh</Typography>
          { isFetching ? <CircularProgress size="20px" color="inherit" sx={{ml: 1}}/> : <RefreshIcon/>}
        </Button>

        <Button variant="outlined" color="warning" sx={{ml: 1}} onClick={onDelete}
                disabled={isFetching || updateGroupProfile.isChangeAllowed}>
          <Typography>Delete</Typography>
          { isDeletePending ? <CircularProgress size="20px" color="inherit" sx={{ml: 1}}/> : <Delete/>}
        </Button>
      </Toolbar>

      <Divider sx={{ mt: 2, mb: 2 }} />

      {
        isLoading || !data
          ? <Skeleton/>
          : <>
            <UpdateGroupProfileForm {...updateGroupProfile}/>
            {data && data.updateStrategy === UpdateStrategyDto.Pinned && <UpdateGroupProductVersionForm {...updateGroupProductVersionProfile} sx={{mt: 2}}/>}

            <UpdateGroupAssignedFarmsForm {...updateGroupAssignedFarmsProfile} />

            <UpdateGroupAvailableFarmsForm {...updateGroupAvailableFarmsProfile} />

            <UpdateGroupUserAccessForm {...updateGroupUserAccessProfile} sx={{mt: 2}} />
          </>
      }

    </Stack>
  );
}

export default UpdateGroupItemPage;
